import { ICON_COLOR } from '@zep-us/zus/tokens';
import { useTranslation } from 'next-i18next';
import { PictureIcon } from '@/icons';
import { IconButton } from '@/ui_v3';
import { Button } from '@/ui_v3';
export const ImageAddButton = ({
  onClick
}: {
  onClick: () => void;
}) => {
  const {
    t
  } = useTranslation(['build']);
  return <>
      <Button onClick={onClick} variant="transparent" intent="neutral" size="xs" className="hidden mobile-lg:flex" leftSlot={<PictureIcon size="xs" fill={ICON_COLOR.neutral} />} data-sentry-element="Button" data-sentry-source-file="ImageAddButton.tsx">
        {t('build:question.addImage')}
      </Button>
      <IconButton onClick={onClick} size="xs" variant="transparent" intent="neutral" className="flex mobile-lg:hidden" data-sentry-element="IconButton" data-sentry-source-file="ImageAddButton.tsx">
        <PictureIcon size="xs" fill={ICON_COLOR.neutral} data-sentry-element="PictureIcon" data-sentry-source-file="ImageAddButton.tsx" />
      </IconButton>
    </>;
};